import styles from './ResultBar.module.scss'
import Button from '@/components/buttons/Button/Button'
import DefaultInput from '@/components/inputs/DefaultInput/DefaultInput'
import DefaultPicker from '@/components/inputs/DefaultPicker/DefaultPicker'
import React from 'react'
import { useTranslation } from 'next-i18next'
import ListViewIcon from '@/assets/svg/list-view.svg'
import CardViewIcon from '@/assets/svg/card-view.svg'
import GalleryViewIcon from '@/assets/svg/gallery-view.svg'
import { ResultView } from '@/types/ResultView'
import NameValue from '@/types/NameValue'
import { useDeviceType, DeviceType } from '@/utils/hooks/useDeviceType'
import WheelSearchStep from '@/types/WheelSearchStep'

type Props = {
  view: ResultView,
  sort: string,
  onChangeView: (view: ResultView) => void,
  onChangeSort: (sort: string) => void,
  step?: WheelSearchStep,
}

const ResultBar = (props: Props) => {
  const deviceType = useDeviceType()
  const { t } = useTranslation()

  const handleOnChangeSort = (value: string, name: string) => {
    props.onChangeSort(value)
  }

  const sortItems: NameValue[] = [
    { name: t('shop:sortByAvailablity') || '', value: 'availability' },
    { name: t('shop:sortByTitle') || '', value: 'articleText' },
    { name: t('shop:sortByPrice') || '', value: 'price' },
  ]

  return (
    <div className={styles.component}>
      {props.step && props.step >= WheelSearchStep.Rim && (
        <div className={styles.stepContainer}>
          <div className={styles.header}>
            <h3>{t('wheels:step')} 0{props.step}</h3>
            <span>
              {props.step === WheelSearchStep.Rim && t('wheels:stepRim')}
              {props.step === WheelSearchStep.Tyre && t('wheels:stepTyre')}
            </span>
          </div>
        </div>
      )}
      {/* Article text search */}
      <div className={styles.group}>
        {/* <DefaultInput
          searchIcon={true}
          name="search"
          value={props.searchText}
          placeholder={t('search.searchPlaceholderRim') || ''}
          onChange={props.onSearchTextChange}
          small={true}
        />

        <Button
          label={t('search.searchButton') || ''}
          onClick={props.onSearch}
          rounded={true}
          arrow={true}
        /> */}
      </div>

      <div className={styles.group}>
        {/* Select view type */}
        {deviceType === DeviceType.Desktop && (
          <>
            <Button
              label={t('shop:gallery') || ''}
              onClick={() => props.onChangeView(ResultView.Gallery)}
              dark={true}
              rounded={true}
              icon={GalleryViewIcon}
              active={props.view === ResultView.Gallery}
            />

            <Button
              label={t('shop:list') || ''}
              onClick={() => props.onChangeView(ResultView.List)}
              dark={true}
              rounded={true}
              icon={ListViewIcon}
              active={props.view === ResultView.List}
            />
          </>
        )}


        {/* Sorting */}
        <DefaultPicker
          name="sort"
          options={sortItems}
          onChange={handleOnChangeSort}
        />

        {/* Show filter */}
        {/* <Button
          label={t('search.filter') || ''}
          onClick={() => console.log('filter')}
          dark={true}
          rounded={true}
          active={true}
          arrow={true}
        /> */}
      </div>
    </div>
  )
}

export default ResultBar